import { NgClass } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { ClipboardService } from '@services/clipboard.service';

@Component({
  selector: 'app-order-complete-intake-link',
  templateUrl: './order-complete-intake-link.component.html',
  styleUrls: ['./order-complete-intake-link.component.scss'],
  imports: [NgClass],
})
export class OrderCompleteIntakeLinkComponent {
  @Input() public intakeUrl: string = '';

  public copied: boolean = false;

  private readonly clipboardService = inject(ClipboardService);

  /**
   * Copies the intake URL to the clipboard and briefly shows a "Copied!" confirmation.
   */
  public copyUrl(): void {
    this.clipboardService.copy(this.intakeUrl).subscribe((success) => {
      this.copied = success;

      setTimeout(() => (this.copied = false), 2000);
    });
  }

  /**
   * Opens the intake URL in a new browser tab.
   */
  public openIntake(): void {
    window.open(this.intakeUrl, '_blank', 'noopener');
  }
}
